<template class="full-height">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + ` ${form.info}`"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <div style="position: relative; height: 80%">
          <el-table
            v-loading="listLoading"
            size="mini"
            :data="form.formTable"
            border
            fit
            highlight-current-row
            style="width: 100%"
            height="100%"
          >
            <el-table-column align="center" label="項次" width="60" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="ID" :width="form.formChk ? 250 : 160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="info">{{ row.identity }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column v-if="!form.formChk" align="center" label="姓名" width="160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="info">{{ row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="加入時間" width="160">
              <template slot-scope="{ row }">
                <el-tag size="mini" type="success">{{ row.joinTime }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="領隊" width="160">
              <template slot-scope="{ row }">
                <el-tag v-if="row.isTravelLeader" size="mini" type="success">V</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="旅行社">
          <el-select v-model="listQuery.agencyCode" filterable placeholder="請選擇旅行社" clearable>
            <el-option
              v-for="item in agencyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="團號">
          <el-input v-model="listQuery.qry" placeholder="輸入團號" />
        </el-form-item>

        <el-form-item label="團名">
          <el-input v-model="listQuery.qrySecond" placeholder="輸入團名" />
        </el-form-item>

        <el-form-item label="出發區間" style="width: 250px">
          <el-date-picker
            v-model="listQuery.dateFilter"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="狀態" style="width: 180px">
          <el-select clearable v-model="listQuery.status" filterable placeholder="請選擇狀態">
            <el-option
              v-for="item in travelStatusOption"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-button
          type="primary"
          @click="getList"
          icon="el-icon-search"
          circle
          style="margin-top: 8px; margin-left: 5px"
          :disabled="listLoading"
        ></el-button>

        <el-button
          style="cursor: pointer"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="團號"
          width="160"
          fixed="left"
          :fixed="device !== 'mobile' ? 'left' : null"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.tourGroupNo }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="團名"
          width="200"
          fixed="left"
          :fixed="device !== 'mobile' ? 'left' : null"
        >
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <div>
                <el-tag style="font-size: 14px">
                  出發
                  <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                  <br />
                  回程
                  <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="110">
          <template slot-scope="scope">
            <el-tag :type="statusTranslateStyle(scope.row.status)">{{
              scope.row.statusDesc
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社代碼" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.agencyCode }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社名稱" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.agencyName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="領隊" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="info">{{ row.leaderUserName }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="導覽開始時間" width="160">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success">{{ row.guideEvent.startTime }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="導覽結束時間" width="160">
          <template slot-scope="{ row }">
            <el-tag v-if="row.guideEvent.endTime" size="mini" type="danger">{{
              row.guideEvent.endTime
            }}</el-tag>
            <el-tag v-else-if="row.status == 1 && row.guideEvent.users.length == 0" size="mini"
              >導覽執正在結束</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅客紀錄" width="150">
          <template v-if="row.status == 0" slot-scope="{ row }">
            <el-button
              v-if="row.guideEvent.users.length > 0"
              size="mini"
              type="success"
              @click="editData(row, row.guideEvent.users, false)"
              >旅客收聽({{ row.guideEvent.users.length }})</el-button
            >
          </template>

          <template slot-scope="{ row }">
            <el-button
              v-if="row.guideEvent.users.length > 0"
              size="mini"
              type="success"
              @click="editData(row, row.guideEvent.users, false)"
              >旅客收聽({{ row.guideEvent.users.length }})</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="導遊紀錄" width="150">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.guideEvent.leaders.length && row.guideEvent.leaders.length > 0"
              size="mini"
              type="primary"
              @click="editData(row, row.guideEvent.leaders, true)"
              >導遊紀錄({{ row.guideEvent.leaders.length }})</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { mapGetters } from 'vuex'

import { getAgencyOptions, getGroupTourGuideRecordList } from '@/api/travel'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'GuideRecord',
  components: {
    Pagination,
  },
  computed: {
    ...mapGetters(['userInfo', 'device', 'showDownloadLoading']),
  },
  data() {
    return {
      funcName: '語音導覽紀錄',
      agencyList: [],
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: { formTable: [], info: '' },
      formChk: false,
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: null,
      },
      total: 0,
      list: [],
      travelStatusOption: [
        { key: 'isOver', value: 0, label: '已結束' },
        { key: 'isLive', value: 1, label: '進行中' },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  async created() {
    this.form = defaultForm
    await this.getAgencyOptions()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async getAgencyOptions() {
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
      })
    },
    statusTranslateStyle(status) {
      let r = ''
      switch (status) {
        case 0:
          r = 'danger'
          break
        case 1:
          r = 'success'
          break
        default:
          break
      }
      return r
    },
    editData(row, ary, isLeader) {
      let travelInfo = row
      let event = row.guideEvent
      this.form.formTable = ary
      this.form.formChk = isLeader
      this.form.info = `${travelInfo.agencyName} ${travelInfo.travelName} ${event.startTime} ~ ${event.endTime} (${isLeader ? '導遊' : '旅客'})`
      this.dialogVisible = true
    },
    async saveData() {},
    async getList() {
      const vm = this
      vm.listLoading = true
      await getGroupTourGuideRecordList(vm.listQuery).then(response => {
        response.data.data.forEach(f => {
          f.networkSettingLoading = false
        })
        vm.list = response.data.data
        console.log(vm.list)
        vm.total = response.data.total
        vm.listLoading = false
      })
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
